import { apiSlice } from "app/api/apiSlice";

export const SaathiApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllSathi: builder.query({
      query: ({
        pagination,
        searchKey,
        category,
        state,
        district,
        status,
        startDate,
        endDate,
        hasCompletedKyc,
        hasBankDetails,
        downloadable,
      }) => {
        const params = new URLSearchParams({
          limit: pagination.limit?.toString(),
          offset: pagination.offset?.toString(),
          page: pagination.currentPage?.toString(),
          search: searchKey || "",
          category: category || "",
          state_name: state || "",
          district_name: district || "",
          status: status || "",
          start_date: startDate || "",
          end_date: endDate || "",
          has_completed_kyc: hasCompletedKyc || false,
          has_bank_details: hasBankDetails || false,
          is_downloadable: downloadable || false,
        });

        return `/empanelment/api/user-list?${params.toString()}`;
      },
    }),

    getSathiDetailsbyId: builder.query({
      query: (id) => `/empanelment/api/user-detail/${id}`,
    }),
    SaathiAprrovalbyId: builder.mutation({
      query: ({ ApplicantId, approval }) => ({
        url: `/empanelment/api/empanelment/action/${ApplicantId}`,
        method: `PATCH`,
        body: approval,
      }),
    }),
    getSathiAgreementForm: builder.query({
      query: (id) => `/empanelment/api/empanelment-form/download/${id}`,
    }),

    UploadAgreementForm: builder.mutation({
      query: ({ ApplicantId, formData }) => ({
        url: `/empanelment/api/empanelment-form/upload/${ApplicantId}`,
        method: `PATCH`,
        body: formData,
      }),
    }),
    regenerateSaathiForm: builder.query({
      query: (id) => `/empanelment/api/re-generate-empanelment-form/${id}`,
    }),
  }),
});

export const {
  useGetAllSathiQuery,
  useGetSathiDetailsbyIdQuery,
  useSaathiAprrovalbyIdMutation,
  useGetSathiAgreementFormQuery,
  useUploadAgreementFormMutation,
  useRegenerateSaathiFormQuery,
} = SaathiApiSlice;
